import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MemberDataModel } from '../model';

@Pipe({
  name: 'getMemberName',
})
export class GetMemberNamePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(value: MemberDataModel): string {
    if (!value) {
      return '';
    }
    const currentLang = this.translate.currentLang;
    const key = currentLang == 'ar' ? 'arabicName' : 'englishName';
    const _dKey = currentLang == 'ar' ? 'englishName' : 'arabicName';
    return value?.[key] ?? value?.[_dKey];
  }
}
